//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LocaleSwitcher from "@/components/LocaleSwitcher";
import AvareNumeric from "@/components/avareNumeric";
import { mapState } from "vuex";

export default {
  name: "NumericSimple",
  props: ["label", "numericvalue", "disabled"],
  components: { AvareNumeric },

  data() {
    return { numberDecimal: 0 };
  },

  computed: {
    ...mapState("main", ["company"]),
  },
  methods: {
    updateVal(newVal) {
    
      var parsedVal = null;
      if (newVal) parsedVal = parseFloat(newVal.replace(",", "."));
      if (parsedVal % 1 != 0) {
        var test1 = parsedVal
          .toString()
          .split(".")[1]
          .substring(0, this.numberDecimal);
        var test0 = parsedVal.toString().split(".")[0];
        var test3 = test0 + "." + test1;
        parsedVal = parseFloat(test3);

    
      }
      if (isNaN(parsedVal)) parsedVal = null;
      this.$emit("update:numericvalue", parsedVal);
      this.$emit("onChange", parsedVal);
    },
  },
  async mounted() {
    // GET request using fetch with error handling
    this.numberDecimal = parseInt(this.company.showNumberOfDecimals);
 
  },
};
